"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pause = void 0;
var _InnerPopupWrapperStyled = require("../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _Button = _interopRequireDefault(require("../../Button"));
var _popupSlice = require("../../../redux/popupSlice");
var _reactI18next = require("react-i18next");
var _store = require("../../../redux/store");
var _jsxRuntime = require("react/jsx-runtime");
const Pause = _ref => {
  let {
    pauseOffer,
    handleClick
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ContentStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
      children: t('unsubscribe-popup.pause-title', 'Would you like to pause your subscription instead?')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
      children: t('unsubscribe-popup.pause-question', 'Need to step away? No problem.')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
      children: t('unsubscribe-popup.pause-description', 'Pause your subscription until the beginning of next season, you can resume at any time.')
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      $fillWrapper: true,
      $customMargin: "80px 0 0",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "confirm",
        onClickFn: () => dispatch((0, _popupSlice.showPopup)({
          type: 'pauseSubscription',
          data: {
            offerData: {
              ...pauseOffer
            },
            isPartOfCancellationFlow: true
          }
        })),
        children: t('unsubscribe-popup.pause-button-text', 'Pause')
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
      children: t('unsubscribe-popup.still-cancel', 'Or still wants to cancel a subscription?')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
      $removeMargin: true,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "simple",
        onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
        children: t('unsubscribe-popup.back-button', 'Back to My Account')
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        theme: "primary",
        onClickFn: handleClick,
        children: t('unsubscribe-popup.unsubscribe-button-text', 'Unsubscribe')
      })]
    })]
  });
};

// eslint-disable-next-line import/prefer-default-export
exports.Pause = Pause;